module.exports = __webpack_public_path__ + "4cb309a123c4e9b903da3d0c701db1e9.fbx";